import { render, staticRenderFns } from "./SetupWhitelisted.vue?vue&type=template&id=70ad4b4a&scoped=true&"
import script from "./SetupWhitelisted.vue?vue&type=script&lang=js&"
export * from "./SetupWhitelisted.vue?vue&type=script&lang=js&"
import style0 from "./SetupWhitelisted.vue?vue&type=style&index=0&id=70ad4b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad4b4a",
  null
  
)

export default component.exports